import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withRouter } from "react-router-dom";
import {
  translate,
  DashboardMenuItem,
  MenuItemLink,
  WithPermissions,
  Responsive,
} from "react-admin";

import SubMenu from "./SubMenu";
import OngoingProjectIcon from "@material-ui/icons/Label";
import SystemIcon from "@material-ui/icons/Assistant";
import ProjectIcon from "@material-ui/icons/Collections";
import ConfigAdminIcon from "@material-ui/icons/Settings";
import PotentialProjectIcon from "@material-ui/icons/Explore";
import ConfigAdminAreaIcon from "@material-ui/icons/PieChart";
import ConfigAdminPhaseIcon from "@material-ui/icons/Adjust";
import ConfigAdminCountryIcon from "@material-ui/icons/LocationOn";
import ConfigAdminPositionIcon from "@material-ui/icons/Portrait";
import JobIcon from "@material-ui/icons/RecentActors";
import UserIcon from "@material-ui/icons/People";
import ContactIcon from "@material-ui/icons/People";
import CandidateIcon from "@material-ui/icons/People";
import NewsletterIcon from "@material-ui/icons/Collections";

class Menu extends Component {
  state = {
    menuProjects: false,
    menuConfigAdmin: false,
    menuPeople: false,
  };

  static propTypes = {
    onMenuClick: PropTypes.func,
    logout: PropTypes.object,
  };

  handleToggle = (menu) => {
    this.setState((state) => ({ [menu]: !state[menu] }));
  };

  render() {
    const { onMenuClick, open, logout, translate } = this.props;
    return (
      <div>
        {" "}
        <DashboardMenuItem onClick={onMenuClick} />
        <WithPermissions
          render={({ permissions }) =>
            permissions === "admin" ? (
              <SubMenu
                handleToggle={() => this.handleToggle("menuPeople")}
                isOpen={this.state.menuPeople}
                sidebarIsOpen={open}
                name="People"
                icon={<SystemIcon />}
              >
                <MenuItemLink
                  to={`/candidates`}
                  primaryText="Candidates"
                  leftIcon={<CandidateIcon />}
                  onClick={onMenuClick}
                />
                <MenuItemLink
                  to={`/contacts`}
                  primaryText="Contacts"
                  leftIcon={<ContactIcon />}
                  onClick={onMenuClick}
                />
                <MenuItemLink
                  to={`/newsletters`}
                  primaryText="Newsletter"
                  leftIcon={<NewsletterIcon />}
                  onClick={onMenuClick}
                />
              </SubMenu>
            ) : null
          }
        />
        <SubMenu
          handleToggle={() => this.handleToggle("menuProjects")}
          isOpen={this.state.menuProjects}
          sidebarIsOpen={open}
          name="Projects"
          icon={<ProjectIcon />}
        >
          <MenuItemLink
            to={`/ongoingProjects`}
            primaryText={translate(`Ongoing`, {
              smart_count: 2,
            })}
            leftIcon={<OngoingProjectIcon />}
            onClick={onMenuClick}
          />
          <MenuItemLink
            to={`/potentialProjects`}
            primaryText={translate(`Potential`, {
              smart_count: 2,
            })}
            leftIcon={<PotentialProjectIcon />}
            onClick={onMenuClick}
          />
        </SubMenu>
        <MenuItemLink
          to={`/jobs`}
          primaryText={translate(`Jobs`, {
            smart_count: 2,
          })}
          leftIcon={<JobIcon />}
          onClick={onMenuClick}
        />
        <WithPermissions
          render={({ permissions }) =>
            permissions === "admin" ? (
              <MenuItemLink
                to={`/users`}
                primaryText={"Users"}
                leftIcon={<UserIcon />}
                onClick={onMenuClick}
              />
            ) : null
          }
        />
        <WithPermissions
          render={({ permissions }) =>
            permissions === "admin" ? (
              <SubMenu
                handleToggle={() => this.handleToggle("menuConfigAdmin")}
                isOpen={this.state.menuConfigAdmin}
                sidebarIsOpen={open}
                name="Config"
                icon={<ConfigAdminIcon />}
              >
                <MenuItemLink
                  to={`/areas`}
                  primaryText="Areas"
                  leftIcon={<ConfigAdminAreaIcon />}
                  onClick={onMenuClick}
                />
                <MenuItemLink
                  to={`/phases`}
                  primaryText="Phases"
                  leftIcon={<ConfigAdminPhaseIcon />}
                  onClick={onMenuClick}
                />
                <MenuItemLink
                  to={`/countries`}
                  primaryText="Countries"
                  leftIcon={<ConfigAdminCountryIcon />}
                  onClick={onMenuClick}
                />
                <MenuItemLink
                  to={`/positions`}
                  primaryText="Positions"
                  leftIcon={<ConfigAdminPositionIcon />}
                  onClick={onMenuClick}
                />
              </SubMenu>
            ) : null
          }
        />
        <Responsive
          small={logout}
          medium={null} // Pass null to render nothing on larger devices
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.admin.ui.sidebarOpen,
  theme: state.theme,
  //locale: state.i18n.locale,
});

const enhance = compose(withRouter, connect(mapStateToProps, {}), translate);

export default enhance(Menu);


// WEBPACK FOOTER //
// ./src/layout/Menu.js